Language:
  description: 언어
  type: string
  default: jpn
  enum:
    - kor
    - eng
    - jpn

OperationAuthority:
  country_code: jpn
  use_my_desktop: true
  use_my_box: true
  use_shared_box: true
  use_project_box: false
  use_link: true
  use_email: true
  use_uploadrequest: true
  use_control_center: true
  use_direct_print: false
  use_directview: false
  use_directboard: false
  use_directnote: false
  richview_node:
  use_office_view: true
  use_media_view: true
  use_pdf_view: true
  use_versioning: true
  use_trash: true
  trash_expire: 7
  app_send_email: false
  app_send_another_app: false
  app_auto_delete_cache: 6
  use_web_pc: true
  use_web_mobile: false
  use_comment: true
  use_comment_alarm: true
  max_upload_size: 10737418240
  max_preview_size: 104857600
  max_media_preview_size: 734003200
  use_guest_invite: true
  use_guest_restrict: false
  logo_img_url:
  mobile_logo_img_url:
  mobile_custom_text:
  use_tag: true
  use_zipmail: true
  use_offline: false
  zipmail_password: false
  use_display: false
  start_menu: 1
  upload_status: 0
  preview_status: 0
  download_status: 0
  flag_quota_limit: true
  flag_auto_delete_dir: true
  autologout_flag_web: false
  autologout_flag_pc: true
  autologout_flag_drive: true
  autologout_flag_mobile: false
  autologout_time: 12H
  login_alarm_flag: false
  is_sharedbox_creator: true
  talk_flag_icon: true
  drenvironment: master
  browser_name: Other
  use_wf: true
  wf_scope_download: true
  wf_scope_link: true
  wf_scope_zipmail: true
  wf_scope_upload: true
  wf_line_user_limit: false
  wf_download_limit: true
  wf_download_day: 90
  wf_line_perm: true
  wf_download_perm: false
  wf_link_perm: false
  wf_zipmail_perm: false
  wf_approver_perm: false
  wf_task_count: 0
  wf_upload_perm: false
  use_azure: true
  azure_login_limit: false
  azure_user: false
  use_smtp: true
  use_upload_limit: false
  upload_limit_scope_mybox: false
  upload_limit_scope_sharedbox: false
  upload_limit_whitelist_extension:
  upload_limit_blacklist_extension:
  use_upload_size_limit: false
  upload_limit_file_size_limit: 0
  use_file_permission: true
  item_code: Premium
  password_option_without: true
  password_option_with: true
  password_option_sender: true
  password_option_not_sent: true
  flag_trial: false
  link_version: 2
  use_finder: true
  option_same_name_upload: choose
  flag_immediate_upload_alarm: true